import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import createHistory from "history/createBrowserHistory";
// 'routerMiddleware': the new way of storing route changes with redux middleware since rrV4.
import { routerMiddleware } from "react-router-redux";

import { ENABLE_REDUX_DEVTOOLS } from "config/constants";
import rootReducer from "../reducers";

export const history = createHistory();

const enhancedCompose = () => {
  if (
    ENABLE_REDUX_DEVTOOLS &&
    "__REDUX_DEVTOOLS_EXTENSION_COMPOSE__" in window
  ) {
    return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  } else {
    return compose;
  }
};

export default function configureStore(initialState) {
  const reactRouterMiddleware = routerMiddleware(history);
  const middlewares = [
    // Add other middleware on this line...

    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
    thunk,
    reactRouterMiddleware,
  ];

  const store = createStore(
    rootReducer,
    initialState,
    enhancedCompose()(applyMiddleware(...middlewares))
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("../reducers", () => {
      const nextReducer = require("../reducers").default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}
